import React from 'react';
import classNames from 'classnames';

import {Layouts} from '@components';
import {Props} from './types';

import './index.scss';

const Main: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  return (
    <div className={classNames('a__terms', {after: isAuthed})}>
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}

      <div className="b__content-main">
        <div className="w__terms-content">
          <div className="w__terms-header">
            <span>利用規約</span>
          </div>
          <div className="w__terms-messages">
            {/* ダミー文言 */}
            <span>
              この利用規約（以下、「本規約」といいます。）は、株式会社ターン・アンド・フロンティア（以下、「当社」といいます。）がこのウェブサイト上で提供するサービスである、AnpiChecker（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。
              <br />
              <br />
              <br />
              第１条（適用）
              <br />
              <br />
              本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
              <br />
              <br />
              第２条（規約等の変更）
              <br />
              <br />
              当社はユーザーの了解を得ることなく、本規約を変更する場合があります。この場合に、本サービスの利用条件は、変更後の本規約に準ずるものとします。当社は、本サービスの内容を自由に変更できるものとし、変更後の本規約は、当社が別途定める場合を除き、本サービスのWebサイト上に表示した時点より、効力を生じるものとします。変更後にユーザーが本サービスを利用した場合又は会員登録をしているユーザーについて、当社の定める期間内に登録取消の手続をとらなかった場合、ユーザーは、本規約の変更に同意したものとみなします。
              <br />
              <br />
              第３条（利用登録）
              <br />
              <br />
              登録希望者が当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了するものとします。当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
              <br />
              （1）利用登録の申請に際して虚偽の事項を届け出た場合
              <br />
              （2）本規約に違反したことがある者からの申請である場合
              <br />
              （3）その他、当社が利用登録を相当でないと判断した場合
              <br />
              <br />
              第４条（ユーザーIDおよびパスワードの管理）
              <br />
              <br />
              ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを管理するものとします。ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
              <br />
              <br />
              第５条（禁止事項）
              <br />
              <br />
              ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
              <br />
              （1）法令または公序良俗に違反する行為
              <br />
              （2）犯罪行為に関連する行為
              <br />
              （3）当社のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
              <br />
              （4）当社のサービスの運営を妨害するおそれのある行為
              <br />
              （5）他のユーザーに関する個人情報等を収集または蓄積する行為
              <br />
              （6）他のユーザーに成りすます行為
              <br />
              （7）当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
              <br />
              （8）その他、当社が不適切と判断する行為
              <br />
              <br />
              第６条（本サービスの提供の停止等）
              <br />
              <br />
              当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
              <br />
              （1）本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
              <br />
              （2）地震、落雷、火災、停電または天災などの自然災害や不可抗力により、本サービスの提供が困難となった場合
              <br />
              （3）コンピュータまたは通信回線等が事故により停止した場合
              <br />
              （4）当社が本サービスの提供が困難と判断した場合当社は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。
              <br />
              <br />
              第７条（利用制限および登録抹消）
              <br />
              <br />
              当社は、以下の場合には事前の通知なく、ユーザーに対して本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
              <br />
              （1）本規約のいずれかの条項に違反した場合
              <br />
              （2）登録事項に虚偽の事実があることが判明した場合
              <br />
              （3）その他、当社が本サービスの利用を適当でないと判断した場合当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
              <br />
              <br />
              第８条（免責事項）
              <br />
              <br />
              当社の債務不履行責任は、当社の故意または重過失によらない場合には免責されるものとします。
              当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
              <br />
              <br />
              第９条（サービス内容の変更等）
              <br />
              <br />
              当社は、ユーザーに通知することなく、本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし、これによってユーザーに生じた損害について一切の責任を負いません。
              <br />
              <br />
              第１０条（通知または連絡）
              <br />
              <br />
              ユーザーと当社との間の通知または連絡は、当社の定める方法によって行うものとします。
              <br />
              <br />
              第１１条（権利義務の譲渡の禁止）
              <br />
              <br />
              ユーザーは、当社の書面もしくは電子メールによる事前の承諾なく、利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し、または担保に供することはできません。
              <br />
              <br />
              第１２条（準拠法・裁判管轄）
              本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
            </span>
          </div>
        </div>
      </div>
      {!isAuthed && <Layouts.Footer.Main />}
    </div>
  );
};

export default Main;
